<ng-container *transloco="let t; prefix: 'trip-finances.assignment'">
  <div class="mt-4 border-t border-primary-border pt-4">
    <label class="flex cursor-pointer items-center gap-2">
      <input
        type="checkbox"
        class="h-4 w-4"
        [checked]="assignEnabled() === 1"
        (change)="onAssignToggle($any($event.target).checked)"
      />
      <span class="font-medium">{{ t('assign-to-participants') }}</span>
    </label>

    @if (assignEnabled() === 1) {
      <div class="mt-4 overflow-x-auto">
        <table class="w-full text-sm">
          <thead>
            <tr class="border-b border-primary-border text-left">
              <th class="px-2 py-2">{{ t('participant') }}</th>
              <th class="px-2 py-2 text-right">{{ t('amount') }}</th>
            </tr>
          </thead>
          <tbody>
            @for (row of rows(); track row.userId) {
              <tr class="border-b border-primary-border/50">
                <td class="px-2 py-2">
                  <label class="flex items-center gap-2">
                    <input
                      type="checkbox"
                      class="h-4 w-4"
                      [checked]="row.selected"
                      (change)="toggleRow(row, $any($event.target).checked)"
                    />
                    {{ row.name }}
                  </label>
                </td>
                <td class="px-2 py-2 text-right">
                  <input
                    type="number"
                    min="0"
                    step="0.01"
                    class="w-28 rounded-md border border-primary-border bg-primary-bg px-2 py-1 text-right text-sm"
                    [ngModel]="row.amount"
                    (ngModelChange)="updateAmount(row, $event)"
                    [disabled]="!row.selected"
                  />
                </td>
              </tr>
            }
          </tbody>
          <tfoot>
            <tr class="font-semibold" [class.text-danger]="!isValid()">
              <td class="px-2 py-2 text-right">{{ t('assigned-total') }}:</td>
              <td class="px-2 py-2 text-right">{{ assignedTotal() | currency }}</td>
            </tr>
            <tr class="font-semibold" [class.text-danger]="!isValid()">
              <td class="px-2 py-2 text-right">{{ t('remaining') }}:</td>
              <td class="px-2 py-2 text-right">{{ remaining() | currency }}</td>
            </tr>
          </tfoot>
        </table>
      </div>

      <div class="mt-3 flex flex-wrap gap-2">
        <button
          type="button"
          class="rounded-md border border-primary-border px-3 py-1 text-sm hover:bg-secondary-bg"
          (click)="selectAll(true)"
        >
          {{ t('select-all') }}
        </button>
        <button
          type="button"
          class="rounded-md border border-primary-border px-3 py-1 text-sm hover:bg-secondary-bg"
          (click)="selectAll(false)"
        >
          {{ t('select-none') }}
        </button>
        <button
          type="button"
          class="rounded-md border border-primary-border px-3 py-1 text-sm hover:bg-secondary-bg"
          (click)="splitEqually()"
        >
          {{ t('split-equally') }}
        </button>
      </div>

      @if (!isValid()) {
        <p class="mt-2 text-sm text-danger">{{ t('assignment-must-match') }}</p>
      }
    }
  </div>
</ng-container>
